import { useState, useEffect } from 'react';
import axios from 'axios';
import { Badge } from '@/components/ui/badge';
import { Award, Star } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const ReputationBadge = ({ sessionId, compact = true }) => {
  const [reputation, setReputation] = useState(null);

  useEffect(() => {
    if (sessionId) {
      fetchReputation();
    }
  }, [sessionId]);

  const fetchReputation = async () => {
    try {
      const response = await axios.get(`${API}/reputation/${sessionId}`);
      setReputation(response.data);
    } catch (error) {
      console.error('Error fetching reputation:', error);
    }
  };

  if (!reputation) return null;

  if (compact) {
    return (
      <div className="flex items-center gap-2">
        <Badge variant="outline" className="flex items-center gap-1">
          <Star className="h-3 w-3 text-yellow-600" />
          {reputation.total_score} Rep
        </Badge>
        {reputation.badges && reputation.badges.length > 0 && (
          <Badge variant="secondary" className="flex items-center gap-1">
            <Award className="h-3 w-3" />
            {reputation.badges.length}
          </Badge>
        )}
      </div>
    );
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Award className="h-5 w-5 text-yellow-600" />
          Your Reputation
        </CardTitle>
        <CardDescription>Recognition for insight-oriented contributions</CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="flex items-center justify-between">
          <span className="text-sm font-medium">Total Score</span>
          <Badge variant="default" className="text-lg">
            {reputation.total_score} points
          </Badge>
        </div>

        {reputation.badges && reputation.badges.length > 0 && (
          <div>
            <span className="text-sm font-medium mb-2 block">Badges Earned</span>
            <div className="flex flex-wrap gap-2">
              {reputation.badges.map((badge, idx) => (
                <Badge key={idx} variant="secondary" className="flex items-center gap-1">
                  <Award className="h-3 w-3" />
                  {badge}
                </Badge>
              ))}
            </div>
          </div>
        )}

        <div className="text-xs text-muted-foreground pt-2 border-t">
          <p><strong>+1</strong> Constructive reframing</p>
          <p><strong>+2</strong> Building common ground</p>
          <p><strong>+3</strong> Insight-generating questions</p>
        </div>
      </CardContent>
    </Card>
  );
};

export default ReputationBadge;